import { createRouter, createWebHistory } from 'vue-router';
import HomePage from '@/HomePage.vue';
//import ProfilePage from '@/ProfilePage.vue';
import ChapterPage from '@/ChapterPage.vue';
import FullChapterListPage from '@/FullChapterListPage.vue';
import AboutPage from '@/AboutPage.vue';
import ContactPage from '@/ContactPage.vue';

const router = createRouter({
  history: createWebHistory(), // Use HTML5 history mode
  routes: [
    {
      path: '/',
      name: 'index',
      component: HomePage,
    },
    {
      path: '/chapters',
      name: 'chapters',
      component: FullChapterListPage,
    },
    {
      path: '/about',
      name: 'about',
      component: AboutPage,
    },
    {
      path: '/contact',
      name: 'contact',
      component: ContactPage,
    },
    /*
    {
      path: '/profile/:id',
      name: 'ProfilePage',
      component: ProfilePage,
      props: true  // This will pass the user ID as a prop
    },
    */
    {
    path: '/chapter/a/:id',
    name: 'ChapterPage',
    component: ChapterPage,
    props: true  // This will pass the chapter ID as a prop
    },
  ],
});

export default router;